/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Story_Analysis_LinkInputs */

const en_gc_story_analysis_link = /** @type {(inputs: Gc_Story_Analysis_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore charts and PivotTables`)
};

const zh_gc_story_analysis_link = /** @type {(inputs: Gc_Story_Analysis_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索图表与数据透视表`)
};

/**
* | output |
* | --- |
* | "Explore charts and PivotTables" |
*
* @param {Gc_Story_Analysis_LinkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_story_analysis_link = /** @type {((inputs?: Gc_Story_Analysis_LinkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Story_Analysis_LinkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_story_analysis_link(inputs)
	return zh_gc_story_analysis_link(inputs)
});
export { gc_story_analysis_link as "gc.story.analysis.link" }